var map = {
	"./icon-blocked.svg": "e7f4",
	"./icon-broken-contract-green.svg": "5d17",
	"./icon-broken-gray.svg": "e462",
	"./icon-calendar-purple.svg": "af81",
	"./icon-cellphone-purple.svg": "5994",
	"./icon-celular-gray-with-shield.svg": "65f5",
	"./icon-celular-green-success.svg": "662a",
	"./icon-check.svg": "e179",
	"./icon-chevron-left.svg": "723e",
	"./icon-copy-purple.svg": "93d4",
	"./icon-coverage-purple.svg": "8362",
	"./icon-credit-card.svg": "b07e",
	"./icon-device-cellphone.svg": "5a00",
	"./icon-device-notebook.svg": "7be3",
	"./icon-device-smartwatch.svg": "1047",
	"./icon-device-tablet.svg": "f22f",
	"./icon-devices-green.svg": "2a55",
	"./icon-devices.svg": "ee61",
	"./icon-document-purple.svg": "8b0d",
	"./icon-exterior-gray.svg": "f233",
	"./icon-facebook-gray.svg": "0668",
	"./icon-gift.svg": "062d",
	"./icon-linkedin-gray.svg": "76b3",
	"./icon-liquid-gray.svg": "9544",
	"./icon-notebook-gray-with-shield.svg": "5ed0",
	"./icon-notebook-green-success.svg": "76bf",
	"./icon-pix-purple.svg": "2026",
	"./icon-play.svg": "1f8f",
	"./icon-plus-purple.svg": "8b96",
	"./icon-robbery-gray.svg": "5061",
	"./icon-shield-green.svg": "b385",
	"./icon-smartwatch-gray-with-shield.svg": "8132",
	"./icon-smartwatch-green-success.svg": "afc0",
	"./icon-success-purple.svg": "d7df",
	"./icon-success.svg": "8603",
	"./icon-tablet-gray-with-shield.svg": "9e67",
	"./icon-tablet-green-success.svg": "6474",
	"./icon-theft-gray.svg": "a36d",
	"./icon-validity-purple.svg": "ebdd",
	"./icon-whatsapp-gray.svg": "07e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c844";